import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import {
  ClaimSource,
  ClaimSourceOption,
  ClientType,
  ClientTypeOption,
} from "Types";
import { OIDCClientConfigurationFormFields } from "../../types";
import FormPanel from "../FormPanel/FormPanel";

// for now we only support confidential
export const clientTypeOptions: ClientTypeOption[] = [
  { label: "Confidential - use client secret", id: "confidential" },
  // { label: "Public - do not use client secret", id: "public" },
];

export const claimSourceOptions: ClaimSourceOption[] = [
  { label: "ID token", id: "id_token" },
  { label: "UserInfo endpoint", id: "user_info_endpoint" },
  { label: "Access token", id: "access_token" },
];

function ClientConfiguration(): React.JSX.Element {
  const {
    watch,
    formState: { errors },
  } = useFormContext<OIDCClientConfigurationFormFields>();

  const clientType: ClientType = watch("client_type");

  return (
    <FormPanel
      title="Client configuration"
      byline="These values will be defined in the application integration of your SSO identity provider"
    >
      <Form.TextField
        id="client_id"
        name="client_id"
        label="Client ID"
        isRequired
        errors={errors}
        helperText="Client ID provided by your OpenID Connect provider"
      />
      <Form.Autocomplete
        id="client_type"
        name="client_type"
        label="Authentication type"
        isClearable={false}
        getOptionLabel={(option: ClientType) => {
          return (
            clientTypeOptions.find((clientType) => clientType.id === option)
              ?.label ?? ""
          );
        }}
        options={clientTypeOptions.map((option) => option.id)}
        errors={errors}
        helperText="If application can securely authenticate with the authorization server"
      />
      {clientType === "confidential" ? (
        <Form.TextField
          id="client_secret"
          name="client_secret"
          label="Client secret"
          isRequired
          errors={errors}
          helperText="Client secret provided by your OpenID Connect provider"
          type="password"
        />
      ) : (
        <></>
      )}
      <Form.Autocomplete
        id="claim_source"
        name="claim_source"
        label="Claim source"
        isClearable={false}
        getOptionLabel={(option: ClaimSource) => {
          return (
            claimSourceOptions.find(
              (claimSourceOption) => claimSourceOption.id === option,
            )?.label ?? ""
          );
        }}
        options={claimSourceOptions.map((option) => option.id)}
        errors={errors}
        helperText="Source used to extract user claims"
      />
    </FormPanel>
  );
}

export default ClientConfiguration;
